enum FeedbackTypeEnum {
    Error = "error",
    Warning = "warning",
    Success = "success",
}

export default FeedbackTypeEnum;
